var React = require('react');

function ChevronUp (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("path",{"fill":"#057F45","d":"M20.53 16.57c-.293.292-.767.292-1.06 0L12 9.1l-7.47 7.47c-.14.143-.33.224-.53.224s-.39-.081-.53-.224c-.292-.293-.292-.767 0-1.06l8-8c.293-.292.767-.292 1.06 0l8 8c.292.293.292.767 0 1.06z"})));
}

ChevronUp.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = ChevronUp;

ChevronUp.default = ChevronUp;
